var _path, _path2, _mask, _path3, _mask2, _path4, _line, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2139 31.75C20.2139 30.5074 21.2212 29.5 22.4639 29.5H27.1782C28.4208 29.5 29.4282 30.5074 29.4282 31.75V40.5H20.2139V31.75Z",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4272 25.1786C18.4272 24.1135 19.2907 23.25 20.3558 23.25H29.2844C30.3495 23.25 31.213 24.1135 31.213 25.1786C31.213 26.2437 30.3495 27.1071 29.2844 27.1071H20.3558C19.2907 27.1071 18.4272 26.2437 18.4272 25.1786Z",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_529_7148",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 27.1875H22.4219V29.5312H21.25V27.1875Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 27.1875V25.6875H19.75V27.1875H21.25ZM22.4219 27.1875H23.9219V25.6875H22.4219V27.1875ZM22.4219 29.5312V31.0312H23.9219V29.5312H22.4219ZM21.25 29.5312H19.75V31.0312H21.25V29.5312ZM21.25 28.6875H22.4219V25.6875H21.25V28.6875ZM20.9219 27.1875V29.5312H23.9219V27.1875H20.9219ZM22.4219 28.0312H21.25V31.0312H22.4219V28.0312ZM22.75 29.5312V27.1875H19.75V29.5312H22.75Z",
    fill: "#475467",
    mask: "url(#path-3-inside-1_529_7148)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_529_7148",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.1875H28.6719V29.5312H27.5V27.1875Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.1875V25.6875H26V27.1875H27.5ZM28.6719 27.1875H30.1719V25.6875H28.6719V27.1875ZM28.6719 29.5312V31.0312H30.1719V29.5312H28.6719ZM27.5 29.5312H26V31.0312H27.5V29.5312ZM27.5 28.6875H28.6719V25.6875H27.5V28.6875ZM27.1719 27.1875V29.5312H30.1719V27.1875H27.1719ZM28.6719 28.0312H27.5V31.0312H28.6719V28.0312ZM29 29.5312V27.1875H26V29.5312H29Z",
    fill: "#475467",
    mask: "url(#path-5-inside-2_529_7148)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.75,
    y1: 40.5,
    x2: 40,
    y2: 40.5,
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8228 20.7143V10",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3911 20.715L34.6411 10.8936",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8589 22.4997L39.1089 15.8032",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7861 22.4997L10.5361 15.8032",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 20.715L15 10.8936",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13);
export default __webpack_public_path__ + "static/media/13.75a3fdc9c9c9bd94c1b52567901fe3fd.svg";
export { ForwardRef as ReactComponent };